'use strict';

function SalaryDistributionController(salaryService, $window) {
  var vm = this;
  vm.$onInit = $onInit;

  vm.saveDistribution = saveDistribution;
  vm.automaticDistribution = automaticDistribution;
  vm.exportPaymentIncrease = exportPaymentIncrease;
  vm.sumChanged = sumChanged;

  vm._addEmployeeSums = _addEmployeeSums;

  function $onInit() {
    vm.distribution = vm.data || [];
    vm.sumChanged();
  }

  function saveDistribution() {
    var employeeSums = vm.distribution.distributions.map(function(employee) {
      return { invite: employee.invite, sum: employee.sum };
    });

    return salaryService.update.distribution(vm.round, vm.distribution.sum_to_distribute, employeeSums).then(function(distribution) {
      vm.distribution = distribution.data;
    });
  }

  function automaticDistribution() {
    vm.saveDistribution().then(retrieveDistribution)
    .then(vm.saveDistribution)
    .then(vm.sumChanged);
  }

  function retrieveDistribution() {
    return salaryService.retrieve.automaticDistribution(vm.round)
      .then(function(response) {
        response.data.forEach(function(distribution) {
          vm.distribution.distributions.filter(function (originalDistribution) {
            return originalDistribution.email === distribution.email;
          })[0].sum = distribution.salary;
        });

        return response;
      });
  }

  function exportPaymentIncrease() {
    return vm.saveDistribution().then(function() {
      $window.location = salaryService.urls.distribution.export({id: vm.round});
    });
  }

  function sumChanged() {
    vm.distributionSum = (vm.distribution.distributions || []).reduce(vm._addEmployeeSums, 0);
  }

  function _addEmployeeSums(current, next) {
    return current + next.sum;
  }
}

module.exports = SalaryDistributionController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-distribution/salary-distribution.controller.js
 ** module id = 241
 ** module chunks = 0
 **/